// process.env.NODE_TLS_REJECT_UNAUTHORIZED = "0";
// const XMLHttpRequest = require("xhr2").XMLHttpRequest;
export default class MyJsonHelper {
    public getJsonFromId(id: string): any {
        return new Promise((resolve) => {
            let xhr = new XMLHttpRequest();
            xhr.open("GET", "https://api.myjson.com/bins/" + id, true);
            xhr.send();
            let processRequest = (e) => {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    return resolve(JSON.parse(xhr.responseText));
                } else if (xhr.readyState === 4) {
                    throw (e);
                }
            }
            xhr.onreadystatechange = processRequest;
        });
    }
}
